import { render, staticRenderFns } from "./RequestNewProcess.vue?vue&type=template&id=38821325&scoped=true&"
import script from "./RequestNewProcess.vue?vue&type=script&lang=js&"
export * from "./RequestNewProcess.vue?vue&type=script&lang=js&"
import style0 from "./RequestNewProcess.vue?vue&type=style&index=0&id=38821325&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38821325",
  null
  
)

export default component.exports